import { defineRecipe } from '@plurall/elo-v3';

export const gaugeChartWrapperRecipe = defineRecipe({
  className: 'gauge-wrapper',
  base: {
    position: 'relative',
    margin: '0 auto',
    textAlign: 'center',
    '--gauge-ideal': 'var(--elo-colors-background-tertiary)',
    '--gauge-atual': 'var(--elo-colors-feedback-warning-strongest)',
  },
});

export const gaugeChartContentRecipe = defineRecipe({
  className: 'gauge-content',
  base: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
});

export const gaugeChartAreaRecipe = defineRecipe({
  className: 'gauge-chart__area',
  base: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
});

export const gaugeChartCenterRecipe = defineRecipe({
  className: 'gauge-center',
  base: {
    position: 'absolute',
    top: '58%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
    zIndex: 10,
  },
});

export const gaugeChartCenterContentRecipe = defineRecipe({
  className: 'gauge-center__content',
  base: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
});

export const gaugeChartValueRecipe = defineRecipe({
  className: 'gauge-value',
  base: {
    fontSize: 'font.size.2xlarge',
    fontWeight: 'font.weight.semi.bold',
    color: 'var(--gauge-atual)',
  },
});

export const gaugeChartTotalRecipe = defineRecipe({
  className: 'gauge-total',
  base: {
    marginTop: '-2px',
    fontSize: 'font.size.xsmall',
    color: 'text.tertiary',
  },
});

export const gaugeChartLegendRecipe = defineRecipe({
  className: 'gauge-legend',
  base: {
    position: 'absolute',
    bottom: '-36px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    gap: 'space.24',
    fontSize: 'font.size.small',
    color: 'text.tertiary',
    whiteSpace: 'nowrap',
  },
});

export const gaugeChartLegendItemRecipe = defineRecipe({
  className: 'gauge-legend__item',
  base: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const gaugeChartLegendColorRecipe = defineRecipe({
  className: 'gauge-legend__color',
  base: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '6px',

    "&[data-variant='ideal']": {
      background: 'var(--gauge-ideal)',
    },

    "&[data-variant='atual']": {
      background: 'var(--gauge-atual)',
    },
  },
});
